import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=167fee1a&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HepLogo: require('/vercel/path0/components/general/HepLogo.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,Address: require('/vercel/path0/components/profile/Address.vue').default})
